
<div class="fitting" perfect>
    <mat-form-field>
        <mat-label>{{ 'WINDOW|Wybierz zestaw profili:' | translate }}</mat-label>
        <mat-select [ngModel]='selectedSetId' (ngModelChange)="changeSet($event)">
            <mat-option *ngFor="let set of resolve.profileSets" [value]="set.id">{{ set.name }}</mat-option>
        </mat-select>
    </mat-form-field>
    <icc-select-box
        *ngFor=" let type of profileTypes"
        [title]="profileTypesTitle[type]"
        [description]="selectedSet[type].id ? selectedSet[type].name : ('INTERFACE|Brak' | translate)"
        [imageUrl]="type !== 'glazingBeadShape' && '/files/profile/' + (selectedSet[type].img || '')"
        [buttonText]="'INTERFACE|Zmień' | translate"
        (select)="changeProfile(type, selectedSet[type].id)"
    ></icc-select-box>
</div>
<button mat-raised-button color = "primary" (click)="closeModal()" >
    {{ 'INTERFACE|OK' | translate }}
</button>
